export const PROTECTED = new Set();

const NAME_KEYS = ["name", "first_name", "last_name", "surname", "author_name", "owner_name", "user_name", "display_name", "from_name", "business_name", "seeker_name"];
const add = (v) => { if (typeof v === "string" && v.trim() && v.length < 120) PROTECTED.add(v.trim()); };

export function protectNames(data, depth = 0) {
  if (!data || depth > 6 || typeof data !== "object") return;
  if (Array.isArray(data)) { data.forEach((d) => protectNames(d, depth + 1)); return; }
  NAME_KEYS.forEach((k) => add(data[k]));
  if (data.first_name && data.last_name) add(`${data.first_name} ${data.last_name}`);
  if (data.category && typeof data.title === "string") add(data.title);
  Object.values(data).forEach((v) => { if (v && typeof v === "object") protectNames(v, depth + 1); });
}
